export default __webpack_public_path__ + "static/media/back_to_office_low.bb50c5a2.svg";